// Site-wide constants — single source of truth for SEO, contato e schema.org
export const SITE = {
  name: "Podomasso",
  fullName: "Podomasso — Clínica de Podologia em Belém do Pará",
   url: (typeof window !== "undefined" ? window.location.origin : "https://podomasso.com.br").replace(/\/$/, ""),
  description:
    "Clínica de podologia em Belém do Pará especializada em tratamento dos pés: unha encravada, calos, micoses, pé diabético e mais. Atendimento humanizado com a podóloga Rosa Chagas (CR8M 00017).",
  city: "Belém",
  state: "PA",
  region: "Belém do Pará",
  phone: "+5591802258229",
  phoneDisplay: "(91) 8022-5829",
  whatsapp: "5591802258229",
  whatsappMessage:
    "Olá! Vim pelo site da Podomasso e gostaria de agendar uma avaliação.",
  email: "podomasso@gmail.com",
  professional: {
    name: "Rosa Chagas",
    title: "Podóloga Responsável",
    registry: "CR8M 00017",
  },
  hours: {
    open: "09:00",
    close: "20:00",
    days: "Domingo a Sexta",
    closed: "Sábado",
    schemaDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
  },
  address: {
    locality: "Belém",
    region: "PA",
    country: "BR",
  },
  geo: {
    lat: -1.4558,
    lng: -48.4902,
  },
  social: {
    instagram: "https://instagram.com/podomasso",
  },
} as const;

export const whatsappLink = (msg?: string) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(msg ?? SITE.whatsappMessage)}`;

export const KEYWORDS = [
  "clínica de podologia Belém do Pará",
  "podóloga Belém do Pará",
  "tratamento dos pés Belém do Pará",
  "podologia Belém",
  "Podomasso",
  "Rosa Chagas podóloga",
  "unha encravada Belém",
  "calos Belém",
  "pé diabético Belém",
  "micose nas unhas Belém",
].join(", ");
